import styled from 'styled-components';

export const UnstyledList = styled.ul`
	list-style-type: none;
	padding: 0;
`;
